import IBase from "./base.model";
import ILog from "./log.model";

export type ParamsObject = {[key: string]: string | string[]};

// Item types for Responses API
export enum ItemType {
  Message = 'message',
  FunctionCall = 'function_call',
  FunctionCallOutput = 'function_call_output'
}

export enum Role {
  System = 'system',
  User = 'user',
  Assistant = 'assistant'
}

export interface IMessageItem {
  type: ItemType.Message;
  role: Role;
  content: string;
}

export interface IFunctionCallItem {
  type: ItemType.FunctionCall;
  call_id: string;
  name: string;
  arguments: string;
}

export interface IFunctionCallOutputItem {
  type: ItemType.FunctionCallOutput;
  call_id: string;
  output: string;
  search?: {
    query: ParamsObject;
    logs: ILog[];
  };
}

export type ILogChatItem = IMessageItem | IFunctionCallItem | IFunctionCallOutputItem;

export default interface ILogChat extends IBase {
  app: string;
  name: string;
  items: ILogChatItem[];
}
